define('home/views/PostReplyView',[
    'jquery',
    'underscore',
    'backbone',

    'core/bus',
    'core/mixins/withAlert',
    'core/mixins/withUploadForm',
    'core/strings',
    'core/views/ContentEditableView',
    'core/views/TextareaView',

    'home/templates/postReply',
    'home/templates/blacklistErrorMessage',
    'home/templates/mustVerifyEmail',
], function (
    $,
    _,
    Backbone,

    bus,
    withAlert,
    withUploadForm,
    strings,
    ContentEditableView,
    TextareaView,

    postReplyTemplate,
    blacklistErrorMessageTemplate,
    mustVerifyEmailTemplate
) {
    'use strict';

    var gettext = strings.get;

    var PostReplyView = Backbone.View.extend({
        tagName: 'form',

        className: 'reply-form',

        events: {
            'click [data-action=cancel]': 'hide',
            'submit': 'submitForm',
        },

        postboxAlertSelector: '[role=postbox-alert]',

        initialize: function (options) {
            this.session = options.session;
            this.thread = options.thread;
            this.showSubmitButton = options.showSubmitButton !== false;
            this.showAvatar = options.showAvatar !== false;
            this.placeholderText = options.placeholder;
            this.canUseContentEditable = options.canUseContentEditable;
            this.showMediaPreviews = options.showMediaPreviews;
            this.showMustVerifyAlert = options.showMustVerifyAlert !== false;

            // TODO: Do not use postboxAlertSelector as the default;
            // the default alert location is expected to be above
            // the textarea, while postboxAlertSelector is below
            this.setAlertSelector(this.postboxAlertSelector);

            this._isHidden = false;

            this.listenTo(this.model, {
                'error': this.onerror,
            });

            // When model gets valid id, it means it has been successfully
            // saved to the server
            this.listenTo(this.model, 'change:id', function () {
                if (!this.model.id)
                    return;

                this.textarea.removeDraft();
            });
        },

        redraw: function () {
            var isExpanded = this.$el.hasClass('expanded');
            var oldEl = this.el;
            var msg = this.$el.find('textarea').val();

            this.render();

            this.$el.find('textarea').val(msg);

            if (isExpanded)
                this.$el.addClass('expanded');

            // Hasn't been appended to DOM yet; no need to update
            if ($(oldEl).parent().length === 0)
                return;

            // If it has, we need to replace the existing DOM element
            // with the new one
            oldEl.parentNode.replaceChild(this.el, oldEl);
        },

        getPlaceholderText: function () {
            return this.placeholderText || 'Discuss…';
        },

        render: function () {
            var $el = this.$el;

            var mediaembedEnabled = this.showMediaPreviews &&
                this.thread.forum.get('settings').mediaembedEnabled;
            var gifPickerEnabled = this.thread.forum.get('settings').gifPickerEnabled;
            var allowUploads = mediaembedEnabled && this.uploadSupported;

            $el.html(postReplyTemplate({
                showAvatar: this.showAvatar,
                showSubmitButton: this.showSubmitButton,
                user: this.session.toJSON(),
                displayMediaPreviews: mediaembedEnabled || gifPickerEnabled,
                displayMediaUploadButton: allowUploads,
            }));

            if (this.model.get('parent'))
                $el.addClass('expanded');
            else
                $el.removeClass('expanded');

            $el.addClass('authenticated');

            this.initTextarea();

            this.initMediaViews({
                mediaembedEnabled: mediaembedEnabled,
                gifPickerEnabled: gifPickerEnabled,
                allowUploads: allowUploads,
                textarea: this.textarea,
            });

            if (this.showMustVerifyAlert &&
                this.constructor.mustVerifyEmailToPost(this.session.user))
                this._alertMustVerify();

            if (this._isHidden)
                $el.addClass('hidden');

            return this;
        },

        initTextarea: function () {
            var TextareaViewClass = this.canUseContentEditable ?
                ContentEditableView :
                TextareaView;

            var textarea = this.textarea = new TextareaViewClass({
                placeholder: this.getPlaceholderText(),
                userSuggestions: this.userSuggestions,

                // If the model has raw_message, it means that we are editing
                // an existing post, rather than creating a new one.
                value: this.model.get('raw_message'),

                storageKey: this.model.storageKey(),
            });

            this.$('[data-role=textarea]').prepend(textarea.render().el);

            this.listenTo(textarea, {
                focus: function () {
                    this.$el.addClass('expanded');

                    // Use _.delay instead of updateDom before triggering resize,
                    // because the 'expanded' class triggers a CSS animation (duration 200ms),
                    // and we can't detect when the animation finishes with JS
                    _.delay(_.bind(this.resize, this), 200);
                },

                blur: function () {
                    this.trigger('blur');
                },
            });
        },

        resize: function () {
            this.textarea.resize();
        },

        focus: function () {
            this.textarea.focus();
        },

        /**
         * Called after a form is submitted; clears the form (and hides it, depending
         * on context)
         */
        clear: function () {
            var self = this;
            self.textarea.clear();

            self.clearMediaPreviews();

            self.$el.removeClass('expanded');

            if (self.model.get('parent'))
                self.hide();
        },

        restore: function (post) {
            var self = this;

            self.textarea.set(post.get('raw_message'));

            // focus in on textarea so that placeholder is removed
            self.textarea.handleFocusIn();

            _.delay(function () {
                self.resize();
            }, 200);

            if (self.model.get('parent'))
                self.show();
        },

        _alertMustVerify: function (error) {
            // This is really gross, but I don't know a better "easy to translate"
            // why of getting the anchor into here.

            var msg = mustVerifyEmailTemplate();

            this.alert(msg, {
                safe: true,
                type: error ? 'error' : 'warn',
                target: error ? this.postboxAlertSelector : null,
            });
        },

        submitForm: function (ev) {
            ev.preventDefault();
            this.dismissAlert();
            return this.createPost();
        },

        onerror: function (_model, response) {
            var self = this;
            var post = this.model;
            var errorMessage;

            if (response.code === 12 && /temporarily do not have permission to post on this thread/.test(response.response)) {
                errorMessage = blacklistErrorMessageTemplate({
                    blocker: this.thread.forum.get('name'),
                    isTemp: true,
                });

                this.alert(errorMessage, { type: 'error', target: this.postboxAlertSelector, safe: true });

            } else if (response.code === 12 && /not have permission to post on this thread/.test(response.response)) {
                errorMessage = blacklistErrorMessageTemplate({
                    blocker: self.session.user.get('isOnGlobalBlacklist') ? 'Disqus' : self.thread.forum.get('name'),
                    isTemp: false,
                });

                self.alert(errorMessage, { type: 'error', target: self.postboxAlertSelector, safe: true });

            } else if (response.code === 12 && /verify/.test(response.response)) {

                self._alertMustVerify(true);

            } else if (_.isString(response.response)) {
                // NOTE: Error responses returned by the API aren't exactly
                //       human-friendly. But we *really* should never hit this
                //       area unless a rare error has occurred. Consider this
                //       an "error of last resort".
                //
                // Sample response:
                // "Invalid argument, 'author_email': Invalid email address"

                self.alert(response.response, { type: 'error', target: self.postboxAlertSelector });
            } else {

                // If we didn't get a response from the server at all we
                // display a generic connection error message.
                self.alert(gettext('Oops! We\'re having trouble posting your comment. Check your internet connection and try again.'), {
                    type: 'error',
                    target: self.postboxAlertSelector,
                });
            }

            self.restore(post);
        },

        createPost: function () {
            var post = this.model;
            this.dismissAlert();

            // If we have ongoing image uploads
            if (this.isUploadInProgress()) {
                return void this.alert(
                    gettext('Please wait until your images finish uploading.'),
                    { type: 'error', target: this.postboxAlertSelector }
                );
            }

            var success = post.save({
                raw_message: this.textarea.get(),
            });

            if (!success) {
                return void this.alert(post.validationError, {
                    type: 'error',
                    target: this.postboxAlertSelector,
                });
            }

            success.done(function () {
                bus.trigger('uiCallback:postCreated', post);
            });

            this.clear();

            return post;
        },

        toggle: function () {
            if (this.isOpen())
                this.hide();
            else
                this.show();
        },

        show: function () {
            var self = this;
            self._isHidden = false;
            self.$el.removeClass('hidden');
            self.trigger('show');
        },

        hide: function () {
            var self = this;
            self._isHidden = true;
            self.dismissAlert();
            self.$el.addClass('hidden');
            self.trigger('hide');
        },

        isOpen: function () {
            return !this._isHidden;
        },
    }, {
        /**
         * Checks if the user needs to verify her email address before
         * posting.
         *
         * @param  {Backbone.Model} user - the user to check
         * @returns {boolean}
         */
        mustVerifyEmailToPost: function (user) {
            return !user.get('isVerified');
        },
    });

    withAlert.call(PostReplyView.prototype);
    withUploadForm.call(PostReplyView.prototype);

    return PostReplyView;
});

